import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useModuleRoleEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.SpaceOpsModuleRoles, false);

  return Boolean(isEnabled);
}